import { z } from 'zod';

const Tepix = z.object({
  isin: z.string().nullable(),
  exchangeCode: z.number(),
  typeOfNonRlcMessage: z.string().nullable(),
  dateTimeOfNonRlcEvent: z.number(),
  lastIndexLevel: z.number(),
  lastIndexLevelVariation: z.number(),
  lastIndexLevelVariationPercentage: z.number(),
  totalNumberOfTrades: z.number(),
  totalTradedValue: z.number(),
  totalNumberOfSharesTraded: z.number(),
  dateTimeOfNonRlcEventAsIso: z.string().nullable(),
});

const TepixResult = z.object({
  totalCount: z.number(),
  items: Tepix.array().nullable(),
});

const MarketMapSymbol = z.object({
  name: z.string().nullable(),
  percent: z.number(),
  value: z.number(),
  volume: z.number(),
  price: z.number(),
  company: z.string(),
  count: z.number(),
  exCode: z.number(),
  isin: z.string(),
});

const MarketMapIndustry = z.object({
  name: z.string().nullable(),
  percent: z.number(),
  sectorCode: z.string().nullable(),
  children: z.array(MarketMapSymbol).nullable(),
});

const MarketMapResult = z.object({
  name: z.string().nullable(),
  children: z.array(MarketMapIndustry).nullable(),
});

const InstrumentGrouping = z.object({
  biggerThanFourPercentage: z.number(),
  betweenThreeAndFourPercentage: z.number(),
  betweenTwoAndThreePercentage: z.number(),
  betweenOneAndTwoPercentage: z.number(),
  betweenZeroAndOnePercentage: z.number(),
  betweenMinusOneAndZeroPercentage: z.number(),
  betweenMinusTwoAndMinusOnePercentage: z.number(),
  betweenMinusThreeAndMinusTwoPercentage: z.number(),
  betweenMinusFourAndMinusThreePercentage: z.number(),
  lessThanMinusFourPercentage: z.number(),
});

const IndexLineChart = z.object({
  c: z.number(),
  oTime: z.string(),
});

const IndexLineChartResult = z.array(IndexLineChart).nullable();

type Tepix = z.infer<typeof Tepix> | undefined;
type TepixResult = z.infer<typeof TepixResult>;
type MarketMapSymbol = z.infer<typeof MarketMapSymbol>;
type MarketMapIndustry = z.infer<typeof MarketMapIndustry>;
type MarketMapResult = z.infer<typeof MarketMapResult>;
type InstrumentGrouping = z.infer<typeof InstrumentGrouping>;
type IndexLineChartResult = z.infer<typeof IndexLineChartResult>;

export {
  TepixResult,
  Tepix,
  MarketMapSymbol,
  MarketMapIndustry,
  MarketMapResult,
  InstrumentGrouping,
  IndexLineChartResult,
};
